import React, { Component } from 'react';
import moment from 'moment';
import { t } from 'i18next';

import CRUDTable from '../../subComponents/CRUDTable/CRUDTableComponent';

// import mockData from './mock';
// import { getResultService } from '../../services/testResultsService';

class FailurePredictionTableComponent extends Component {
  constructor(props) {
    super(props);
    const { threshold, jobName } = this.props;
    this.state = {
      data: [],
      jobName,
      tableLoading: true,
      threshold,
      thresholdTimeout: 0,
    };
    this.getResults = this.getResults.bind(this);
  }

  componentWillReceiveProps(props) {
    const { thresholdTimeout } = this.state;
    if (thresholdTimeout) {
      clearTimeout(thresholdTimeout);
    }

    this.setState({
      thresholdTimeout: setTimeout(() => {
        this.getResults(props.jobName, props.threshold);
      }, 1000),
    });
  }

  shouldComponentUpdate(props, state) {
    const {
      tableLoading, jobName, threshold,
    } = this.state;
    // Avoid refresh when state changes due to modal open/close
    return ! (state.tableLoading === tableLoading && props.jobName === jobName && props.threshold === threshold);
  }

  // Retrieve Table data
  // getResults(jobName, threshold) {
  //   // jobName, threshold
  //   this.setState({
  //     // data: mockData.filter(({ failurePercent }) => failurePercent * 100.0 > threshold),
  //     tableLoading: false,
  //   });
  // }

  render() {
    const {
      data,
      tableLoading,
      jobName,
      threshold,
    } = this.state;
    const columns = [{
      accessor: 'device',
      Header: t('tensorAnalytics.tableHeaders.DSN'),
    }, {
      accessor: 'failurePercent',
      Cell: row => (
        <div>
          {`${row.value} %`}
        </div>
      ),
      Header: t('tensorAnalytics.tableHeaders.failurePercent'),
    }, {
      accessor: 'failureDate',
      Header: t('tensorAnalytics.tableHeaders.failureDate'),
    }];

    return (
      <div className="failure-prediction-table">
        <CRUDTable sortFunction={(a, b) => a.failurePercent - b.failurePercent}
          columns={columns}
          tableLoading={tableLoading}
          style={{
            height: '400px',
          }}
          options={{
            exportToCSV: true,
            exportToCSVOptions: {
              fileName: `${jobName}-${threshold}-${moment().format('DD/MM/YYYY')}`,
            },
          }}
          data={data.map(({
            device, failurePercent, failureDate,
          }) => ({
            device,
            failureDate,
            failurePercent: Math.floor(failurePercent * 100),
          }))}
        />
      </div>
    );
  }
}

export default FailurePredictionTableComponent;
